import { makeAutoObservable } from 'mobx';

class LayoutStore {
  isDrawerOpen = true;

  constructor() {
    makeAutoObservable(this);
  }

  setIsDrawerOpen(isDrawerOpen) {
    this.isDrawerOpen = isDrawerOpen;
    return this.isDrawerOpen;
  }

  getIsDrawerOpen() {
    return this.isDrawerOpen;
  }
}

export default new LayoutStore();
